import React, { useState } from 'react';
import { useApi } from '../hooks/useApi';

const BOTS = ['전체', '워런 버핏', '피터 린치', '레이 달리오', '캐시 우드', '제시 리버모어'];

export default function ScreenerResults() {
  const [selectedBot, setSelectedBot] = useState('전체');
  const botParam = selectedBot === '전체' ? '' : `&bot_name=${encodeURIComponent(selectedBot)}`;
  const { data, loading } = useApi(`/api/fundamental/screener?${botParam}`, [selectedBot]);

  return (
    <div className="bg-gray-800 rounded-lg border border-gray-700">
      <div className="p-3 border-b border-gray-700 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-400">스크리너 결과</h3>
        <select
          value={selectedBot}
          onChange={(e) => setSelectedBot(e.target.value)}
          className="bg-gray-700 text-xs rounded px-2 py-1 text-gray-300 border-none outline-none"
        >
          {BOTS.map((b) => (
            <option key={b} value={b}>{b}</option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="p-4 text-sm text-gray-500">로딩 중...</div>
      ) : !data || data.length === 0 ? (
        <div className="p-4 text-sm text-gray-500">스크리너 결과 없음</div>
      ) : (
        <div className="max-h-80 overflow-y-auto">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-800">
              <tr className="text-gray-500 border-b border-gray-700">
                <th className="text-left p-2">봇</th>
                <th className="text-left p-2">종목</th>
                <th className="text-right p-2">점수</th>
                <th className="text-center p-2">통과</th>
                <th className="text-right p-2">날짜</th>
              </tr>
            </thead>
            <tbody>
              {data.slice(0, 50).map((s, i) => (
                <tr key={i} className="border-b border-gray-700/50">
                  <td className="p-2 text-gray-400">{s.bot_name}</td>
                  <td className="p-2">
                    <span className="font-medium">{s.ticker}</span>
                    <span className="text-gray-500 ml-1">{s.company_name}</span>
                  </td>
                  <td className="text-right p-2">
                    <span className={s.score >= 70 ? 'text-green-400' : s.score >= 50 ? 'text-yellow-400' : 'text-gray-400'}>
                      {Number(s.score).toFixed(1)}
                    </span>
                  </td>
                  <td className="text-center p-2">
                    {s.passed ? (
                      <span className="text-green-400">O</span>
                    ) : (
                      <span className="text-gray-600">X</span>
                    )}
                  </td>
                  <td className="text-right p-2 text-gray-500">{s.screened_date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
